import React, { useState } from "react";
import { Link } from "react-router-dom";
import WebPopUp from "./WebPopUp"; // Import your WebPopUp component
import '../styles/Home.css';
import InterestForm from './InterestForm';

const Home = () => {
 const [showPopUp, setShowPopUp] = useState(true);
  const images = ["EDit COver2.png"];
  const midImages = `midBack.png`;
  const tImages = `long carrot.png`;
  const rImages = `billboard.png`;
  const bbImages = `billboard38.png`;
   const gbImages = `billboard39.png`;
    const cbImages = `billboard40.png`;
     const ocImages = `billboard42.png`;
      const redImages = `billboard43.png`;
      const brImages = `billboard44.png`;
        const bfImages = `billboard46.png`;
          const seImages = `spray edit.png`;
          const eiImages = `edit icon.png`;
          const tsImages = `38.png`;
          const coImages = `cow.png`;
           const preCar = `preCar.png`;
           const dialogo = `dialogo.png`;
           const cartext = `cartext.png`;
             const carrotB = `carrot box.png`;
             const CTB = `the carrot text.png`;
           


  return (
    <div className="cookie-dough">
      {showPopUp && <WebPopUp onClose={() => setShowPopUp(false)} truncate={true} />}


      <div className="griffith">


           <div className="salesFun"> 
      
              <h2> 
              Your Podcast Is Running Expired Promotions 
              </h2>

                        <img 
          src={dialogo} 
          className="dialogo"
          alt="dialogo"
        />
                        <img 
          src={CTB} 
          className="cartext"
          alt="CTB"
        />

          
          <ul>
          <li><span>💎 1. Manage your content&apos;s advertisements –  </span> replace media clips at scale with the press of a button.</li>
          <li><span>💎2. Automatic rendering – </span> create a job and initiate renderings for multiple media projects.</li>
          <li>
              <span>💎 3.  Streamline your workflow – </span> release the bottleneck in your editing projects repetitive tasks. 
          </li>
           <li>
              <span>💎 4. </span>  The Carrot Download restores the value podcasts lose from expired advertisements.  
          </li>
          </ul>

                        <img 
          src={carrotB} 
          className="carrB"
          alt="carrot box"
        />

       
           </div>

        <div>
        
        
        
             
             <div>
             <h1 className="siete">Leave a message with Edit Farmer.</h1>
             <InterestForm />
             </div>

            <div className="home-wrapper">
          <div className="home-card">

           <div>
           <div className="billboard3">
           <img src={eiImages}/>
           </div>
           <h1 className="h1HomeT"> Edit Farmer&apos;s Media Solutions</h1>
           <hr className="newLine"/> 

            <h2>
          💎 1. The Carrot Download 
           </h2>
            <p className="paraD">
           Professional software designed for bulk editing and automated media rendering.
           </p>
           
           <h2>
          <Link className="menuTi" to="/editmedia"> 2. Video Editing Service </Link>
           </h2>
           <p className="paraD">
            Organizing, cutting, and assembling raw media files into digital stories.
           </p>
           </div>

            <div>
           <h2>
           3. Streaming App Development 
           </h2>
           <p className="paraD">
            Development of your organization&apos;s independent streaming service. 
           </p>

           <div className="billboard5">
           <img src={coImages}/>
           </div>
           </div>
            
            </div>
            </div>
           
          <hr className="newLine"/> 
        
         <hr className="newLine"/> 
         <div className="billboard">
          <img src={brImages} />
          </div>
          <div className="h1HomeT">
          <p className="uno">Your content's promotions are expired. The Carrot Download will keep them up to date with
          organization and automation.</p>
          <p className="cuatro"> The Carrot Download is professional editing software that uses file management and
           automated media rendering to keep your advertising campaigns consistent with your current goals.
            </p>


          
            </div>
              <div className="billboard4">
            <img src={tsImages} />
            </div>

          



        </div>
      </div>
    </div>
  );
};

export default Home;
